import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import location from '../assets/images/GroupTraining/location.JPG';
import thumbnail from '../assets/images/GroupTraining/thumbnail2.png';
import ClientsA2 from '../assets/images/GroupTraining/ClientsA2.JPG';
import TrainerC from '../assets/images/GroupTraining/TrainerC.JPG';
import TrainerD from '../assets/images/GroupTraining/TrainerD.JPG';
import EquipmentF from '../assets/images/GroupTraining/equipmentF.JPG';
import OutdoorTrainingVideo from '../assets/images/GroupTraining/outdoor_training.mp4';

function GroupTraining() {
  return (
    <div className='flex flex-col min-h-screen'>
  <Navbar />
  <div className="flex-grow mx-10 lg:mx-10 xl:mx-40 mt-7 lg:mt-14 mb-20">
    <h2 className="text-xl text-center mb-5 sm:mb-7 lg:mb-10 font-bold">
      Group Training
    </h2>

    {/* Responsive Flex Container: stacked on sm+md, side-by-side on lg+ */}
    <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 mb-16">
      {/* TEXT LEFT on lg, TOP on md/sm */}
      <div className="w-full text-justify">
       <p className="mb-2.5">Move, Sweat, and Enjoy Fitness Outdoors - Join a community of like-minded people and get stronger and fitter with workouts that include everything: cardio, strength, and functional training.
        </p>

        <ul className="space-y-3 text-gray-800">
          <li><strong>🟢 WHAT:</strong> Outdoor fitness sessions</li>
          <li><strong>👥 WHO:</strong> Small groups (max. 8 people) - Beginner-friendly</li>
          <li>
            <strong>📍 WHERE: </strong> 
            <a
            rel="noopener noreferrer"
            target="_blank"
            href="https://www.google.com/maps/place/Fuussepad/@49.6775135,6.1045892,15z/data=!4m6!3m5!1s0x47954e166f3a0457:0xed34b18e4e885bd0!8m2!3d49.6792978!4d6.1107011!16s%2Fg%2F11s53hm2vy?entry=ttu&g_ep=EgoyMDI1MDYzMC4wIKXMDSoASAFQAw%3D%3D"
            className="text-blue-600 underline hover:text-blue-800">
            Fuussepad, 7320 Steinsel
            </a>
            <span> (parking on site)</span> 
          </li>
          <li><strong>🕘 WHEN:</strong> Saturdays from 9:00 - 10:00 (exceptions possible)</li>
          <li><strong>💶 PRICE:</strong> 20€ per person</li>
        </ul>

        <div className="mt-10">
          <h2 className="text-xl mb-2.5 font-bold">Registration</h2>
          <p className="mb-2.5">
            Contact me at{" "}
            <a href="mailto:nevskifit@gmail.com" className="text-blue-600 underline">nevskifit@gmail.com</a>
          </p>
          <p className="mb-2.5">Weekly registration, minimum 48 hours before the training.</p>
        </div>
      </div>

        {/* Right: Video */}
        <div className="justify-center">
            <video
              controls
              className="lg:w-2/5 shadow-2xl"
              poster={thumbnail}
              style={{ background: "black" }}
            >
              <source src={OutdoorTrainingVideo} type="video/mp4" />
              Your browser does not support the video.
            </video>
          </div>
        </div>

        {/* IMAGES IN A ROW — always squares, scrollable on iPhone if needed */}
        {/* IMAGES: 2×2 on mobile → one line on desktop */}
        <div className="sm:px-0">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-8 mx-auto">
            <img
              src={EquipmentF}
              alt="Equipment"
              className="w-full aspect-square object-cover shadow-md"
              />
            <img
              src={TrainerC}
              alt="Trainer"
              className="w-full aspect-square object-cover shadow-md"
              />
            <img
              src={TrainerD}
              alt="Trainer"
              className="w-full aspect-square object-cover shadow-md"
              />
            <img
              src={ClientsA2}
              alt="Clients training"
              className="w-full aspect-square object-cover shadow-md"
              />
          </div>
        </div>
      </div>
    <Footer />
  </div>
  );
}

export default GroupTraining;